/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const UploadCloudLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M1 14.5a6.5 6.5 0 0 1 3.06-5.52 8 8 0 0 1 15.88 0 6.5 6.5 0 0 1-2.94 12L7 21a6.53 6.53 0 0 1-6-6.5m15.85 4.49a4.5 4.5 0 0 0 2.03-8.31l-.8-.5-.13-.95a6 6 0 0 0-11.9 0l-.12.95-.8.5a4.5 4.5 0 0 0 2.02 8.3l.17.02h9.36zM13 13v4h-2v-4H8l4-5 4 5z" />
  </Icon>
);
